import { ITranslationEntry } from '../lang';

export const EU: ITranslationEntry = {
  translations: {
    notifications: 'Notificacionespenak',
    markAllAsRead: 'Markatu guztiak irakurrita bezala',
    poweredBy: 'Bultzatuta',
    settings: 'Ezarpenak',
  },
  lang: 'eu',
};
